/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Resume_Upload_CtaInputs */

const en_onboarding_resume_upload_cta = /** @type {(inputs: Onboarding_Resume_Upload_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click to choose file`)
};

const de_onboarding_resume_upload_cta = /** @type {(inputs: Onboarding_Resume_Upload_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klicke zum Auswählen einer Datei`)
};

const fr_onboarding_resume_upload_cta = /** @type {(inputs: Onboarding_Resume_Upload_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clique pour choisir un fichier`)
};

const es_onboarding_resume_upload_cta = /** @type {(inputs: Onboarding_Resume_Upload_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haga clic para elegir archivo`)
};

const it_onboarding_resume_upload_cta = /** @type {(inputs: Onboarding_Resume_Upload_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clicca per scegliere il file`)
};

const nl_onboarding_resume_upload_cta = /** @type {(inputs: Onboarding_Resume_Upload_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klik om bestand te kiezen`)
};

const pl_onboarding_resume_upload_cta = /** @type {(inputs: Onboarding_Resume_Upload_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kliknij, aby wybrać plik`)
};

const fi_onboarding_resume_upload_cta = /** @type {(inputs: Onboarding_Resume_Upload_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse tiedosto`)
};

const da_onboarding_resume_upload_cta = /** @type {(inputs: Onboarding_Resume_Upload_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klik for at vælge fil`)
};

const sv_onboarding_resume_upload_cta = /** @type {(inputs: Onboarding_Resume_Upload_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klicka för att välja fil`)
};

/**
* | output |
* | --- |
* | "Click to choose file" |
*
* @param {Onboarding_Resume_Upload_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_resume_upload_cta = /** @type {((inputs?: Onboarding_Resume_Upload_CtaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Resume_Upload_CtaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_resume_upload_cta(inputs)
	if (locale === "fr") return fr_onboarding_resume_upload_cta(inputs)
	if (locale === "es") return es_onboarding_resume_upload_cta(inputs)
	if (locale === "it") return it_onboarding_resume_upload_cta(inputs)
	if (locale === "nl") return nl_onboarding_resume_upload_cta(inputs)
	if (locale === "pl") return pl_onboarding_resume_upload_cta(inputs)
	if (locale === "fi") return fi_onboarding_resume_upload_cta(inputs)
	if (locale === "da") return da_onboarding_resume_upload_cta(inputs)
	if (locale === "sv") return sv_onboarding_resume_upload_cta(inputs)
	return en_onboarding_resume_upload_cta(inputs)
});